import { render, staticRenderFns } from "./AutorizacaoTermos.vue?vue&type=template&id=39e263da"
import script from "./AutorizacaoTermos.vue?vue&type=script&lang=js"
export * from "./AutorizacaoTermos.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports